import { useState } from "react";
import SewaClientContractTable from "../components/ContractSummary/SewaContract";
import MainLayout from "../layout/MainLayout";
import AirContract from "../components/ContractSummary/AirContract";

const Summary = () =>{

  const [type,setType] = useState('')

  return(
    <MainLayout>
    <div className="p-5">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Kontrak Mengikut Zon
        </h1>
      <label className="mb-3">Chose Client Type </label>
      <select className="mb-2 border w-full py-2 px-3 rounded-lg" onChange={(e)=>setType(e.target.value)}>
        <option value=''>--Chose Client Type--</option>
        <option value='sewa' >Sewa</option>
        <option value='air'>Air</option>
      </select>

      {type === 'sewa' && <SewaClientContractTable/>}
      {type === 'air' && <AirContract/>}
    </div>
    </MainLayout>
  );
}

export default Summary;